import { createProductIdentifiersProto } from 'helpers/analytics';

// As defined here: https://code.amazon.com/packages/AmethystEvents/blobs/e82c1c5363418a1dcb2269219999ee5d88384ac1/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L40
const amethystCancellationReasonCodes = {
  'no-reason': 0,
  'no-longer-want': 1,
  'too-late': 2,
  'duplicate-order': 3,
  'wrong-item': 4
};

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/OrderDetailPageView.proto
export const pvOrderDetail = ({ lineItems }) => ({
  orderDetailPageView: {
    orderedItems: createProductIdentifiersProto(lineItems)
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AddAddressClick.proto
export const evAddAddressClick = ({ addressType }) => ({
  addAddressClick: {
    addressType
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AddPaymentInstrumentClick.proto
export const evAddPaymentInstrumentClick = ({ sourcePage }) => ({
  addPaymentInstrumentClick: { // https://code.amazon.com/packages/AmethystEvents/blobs/5adec2785fb8813a769db8ec29692d7f353486f2/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L74
    sourcePage // 7 for regular MyAccount Payments page; 9 for Order Care (order detail)
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/CancelCheckedItemsClick.proto
export const evCancelCheckedItemsClick = ({ orderId, items }) => ({
  cancelCheckedItemsClick: {
    amazonOrderId: orderId,
    productIdentifiers: createProductIdentifiersProto(items)
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/CancellationReasonSelection.proto
export const evCancellationReasonSelection = ({ orderId, lineItem, reason }) => {
  const { product: { asin, productId, styleId, stockId } } = lineItem;
  return {
    cancellationReasonSelection: {
      productIdentifiers: {
        asin,
        productId,
        styleId,
        stockId
      },
      amazonOrderId: orderId,
      cancellationReason: amethystCancellationReasonCodes[reason]
    }
  };
};

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/EditAddressClick.proto
export const evEditAddressClick = ({ addressType, addressIndex, addressId }) => ({
  editAddressClick: {
    addressType,
    addressIndex,
    addressId
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/SubmitCancellationClick.proto
export const evSubmitCancellationClick = () => ({
  submitCancellationClick: {}
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/CancellationConfirmationPageView.proto
export const pvCancellationConfirmationPageView = ({ items, amazonOrderId }) => ({
  cancellationConfirmationPageView: {
    itemsToCancel: createProductIdentifiersProto(items),
    amazonOrderId
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AddOrEditAddress.proto
export const evAddOrEditAddress = ({ valid, addressId, addressType }) => ({
  addOrEditAddress: {
    passedValidation: valid,
    addressId,
    addressType
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/DeleteAddress.proto
export const evDeleteAddress = ({ addressId, addressType }) => ({
  deleteAddress: {
    addressId,
    addressType
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AddPaymentInstrument.proto
export const evAddPaymentInstrument = ({ valid, paymentInstrumentId, isPrimarySuccess }) => ({
  addPaymentInstrument: {
    passedValidation: valid,
    paymentInstrumentId,
    makeDefaultPaymentInstrument: isPrimarySuccess
  }
});
